module.exports = __webpack_public_path__ + "static/media/dataPointMainLogo.7223f77f.svg";